<div class="container">
  <div class="room-list mt-3 mb-3" *ngIf="rooms && rooms.length > 0">
    <table class="table table-striped table-responsive-lg">
      <thead>
      <tr>
        <th scope="col">#</th>
        <th scope="col">Image</th>
        <th scope="col">Name</th>
        <th scope="col">Name (hebrew)</th>
        <th scope="col">Area</th>
        <th scope="col">Capacity</th>
        <th scope="col">Color</th>
        <th scope="col">Type</th>
        <th scope="col">Office</th>
<!--        <th scope="col" style="white-space: break-spaces; max-width: 80px">Zoom Permissions</th>-->
        <th></th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let room of rooms">
        <td>{{ room.id }}</td>
        <td class="text-center"><img class="img-thumbnail" style="width: 30px; height: 30px;" [src]="room.image" alt=""></td>
        <td>{{ room.name }}</td>
        <td>{{ room.nameHe }}</td>
        <td>{{ room.area }}</td>
        <td>{{ room.capacity }}</td>
        <td>
          <span
            class="room-color-chip"
            [style.backgroundColor]="getRoomColorHex(room.color)"
            [style.color]="getRoomColorTextHex(room.color)"
          >
            {{ room.color }}
          </span>
        </td>
        <td>{{ room.type }}</td>
        <td>{{ getOffice(room.officeId) }}</td>
<!--        <td>-->
<!--          <ng-container *ngIf="(isZoomPermissionGranted(room.id) | async).result; else linkToGrant">-->
<!--            Granted-->
<!--          </ng-container>-->
<!--          <ng-template #linkToGrant>-->
<!--            <a class="link-button" [href]="(getLink(room.id) | async).url">Grant</a>-->
<!--          </ng-template>-->
<!--        </td>-->
        <td class="text-center">
          <button type="button" class="btn btn-light edit-button" (click)="openEditModal(room)">
            <i class="fas fa-pencil"></i>
          </button>
        </td>
        <td class="text-center">
          <button type="button" class="btn btn-danger delete-button" (click)="openDeleteConfirmModal(room)">
            <i class="fas fa-trash"></i>
          </button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <div class="text-center">
    <button type="button" class="btn btn-default add-button" (click)="openEditModal(null)">
      <i class="fas fa-plus"></i> Add new
    </button>
  </div>
</div>
